// extracted by mini-css-extract-plugin
export var anchor = "references-module--anchor--w9Gvk";